import React, { useState, useRef } from 'react';
import { FormControl, FormHelperText, CircularProgress, TextField, Container, Typography, InputLabel, Paper, Toolbar, Select, MenuItem, Divider, Radio, RadioGroup, Button, Grid, Box } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { useForm, Controller } from "react-hook-form";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { ShopActions, NotificationActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const shopsSelector = (state) => state.Shops;
const IdentitySelector = (state) => state.Identity;

const ShopEntryStep1 = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const shopActions = bindActionCreators(ShopActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(shopsSelector);
    const { token, userData } = useSelector(IdentitySelector);

    // React Hook Form
    const { control, errors, handleSubmit, watch } = useForm();
    const password = useRef({});
    password.current = watch("password", "");

    const { classes } = props;

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const handleBack = () => {
        props.handleBack();
    }

    /**
     * 
     * 次へ押下時の処理
     * 
     */
    const handleNext = (data) => {
        props.handleNext();
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        currentState[name] = value;

        if (name.startsWith('merchant_id')) {
            const merchant = editing.selectableMerchants.find(merchant => merchant.id === value);
            currentState['merchant_name'] = merchant.merchant_name;
        }

        return value;
    }

    // submitボタンのアイコンとタイトルを画面に応じて変更
    var submitIcon;
    var submitTitle;
    if (props.mode == "create") {
        // 新規作成時：次へ
        submitIcon = <ArrowForwardIosIcon />;
        submitTitle = <FormattedMessage id="Button.Next" />;
    }
    else {
        // 更新時：登録
        submitIcon = <SaveIcon />;
        submitTitle = <FormattedMessage id="Button.Save" />;
    }

    if (editing.shop_fax == null || editing.shop_fax == undefined) {
        editing.shop_fax = "";
    }
    if (editing.latitude == null || editing.latitude == undefined) {
        editing.latitude = "";
    }
    if (editing.longitude == null || editing.longitude == undefined) {
        editing.longitude = "";
    }

    // 加盟店選択リスト
    var orgElement = null;
    if (userData.role == 1 || userData.role == 2 || userData.role == 3) {
        // システム管理者、沖縄IC、代表加盟店の場合は、一覧画面で選択された加盟店を設定

        if (props.mode == "create") {
            // 新規時は加盟店一覧で選択した加盟店ID
            editing.merchant_id = props.merchantId;
            const merchant = editing.selectableMerchants.find(merchant => merchant.id === editing.merchant_id);
            editing.merchant_name = merchant.merchant_name;
        }
        else {
            // 更新時は登録されている加盟店ID、加盟店名
        }

        // 加盟店一覧で選択済みなので表示のみ
        orgElement =
            <Grid item xs={12}>
                <Controller
                    name="merchant_name"
                    control={control}
                    defaultValue={editing.merchant_name}
                    as={<TextField disabled fullWidth variant="outlined"
                        label={<FormattedMessage id={"Shop.Merchant"} />} />} />
            </Grid>;
    }
    else {
        // 一般加盟店の場合は、ログインユーザの加盟店IDを自動設定

        if (props.mode == "create") {
            // 新規時ははログインユーザの加盟店IDを自動設定
            editing.merchant_id = userData.org_id;
            editing.merchant_name = userData.org_name;
        }
        else {
            // 更新時は登録されている加盟店ID、加盟店名
        }

        // 一般加盟店は表示のみ
        orgElement =
            <Grid item xs={12}>
                <Controller
                    name="merchant_name"
                    control={control}
                    defaultValue={editing.merchant_name}
                    as={<TextField disabled fullWidth variant="outlined"
                        label={<FormattedMessage id={"Shop.Merchant"} />} />} />
            </Grid>;
    }

    // 店舗入力チェック値
    var shopCd3Pattern = /[0-9]{6}/i;
    var shopCd3MaxLength = 6;

    return (
        <form className={classes.form} noValidate>
            <Grid container spacing={2}>

                {orgElement}

                <Grid item xs={12}>
                    <Controller
                        name="shop_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_name}
                        rules={{
                            required: <FormattedMessage id="Error.Required" />,
                            maxLength: { value: 50, message: <FormattedMessage id="Error.ShopName1MaxLenPattern" /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_name && true}
                            helperText={errors.shop_name ? errors.shop_name.message : "例) 沖縄１号店"}
                            label={<FormattedMessage id={"Shop.Name"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="shop_f_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_f_name}
                        rules={{
                            required: <FormattedMessage id="Error.Required" />,
                            maxLength: { value: 50, message: <FormattedMessage id="Error.ShopName1MaxLenPattern" /> },
                            pattern: { value: /^[ァ-ヶー０-９]+$/i, message: <FormattedMessage id="Error.KatakanaName" /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_f_name && true}
                            helperText={errors.shop_f_name ? errors.shop_f_name.message : "例) オキナワ１ゴウテン"}
                            label={<FormattedMessage id={"Shop.ShopFName"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="shop_e_name"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_e_name}
                        rules={{
                            required: <FormattedMessage id="Error.Required" />,
                            maxLength: { value: 100, message: <FormattedMessage id="Error.ShopName2MaxLenPattern" /> },
                            pattern: { value: /^[0-9a-zA-Z ._-]+$/i, message: <FormattedMessage id="Error.Hankakueisu" /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_e_name && true}
                            helperText={errors.shop_e_name ? errors.shop_e_name.message : "例) okinawa1"}
                            label={<FormattedMessage id={"Shop.ShopEName"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="shop_postal_cd"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_postal_cd}
                        rules={{
                            required: <FormattedMessage id="Error.Required" />,
                            minLength: { value: 7, message: <FormattedMessage id="Error.ShopPostalMinLenPattern" />},
                            maxLength: { value: 7, message: <FormattedMessage id="Error.ShopPostalMaxLenPattern" /> },
                            pattern: { value: /^[0-9]+$/i, message: <FormattedMessage id="Error.Number" /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_postal_cd && true}
                            helperText={errors.shop_postal_cd ? errors.shop_postal_cd.message : "例) 9000033"}
                            label={<FormattedMessage id={"Shop.ShopPostalCd"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="shop_adress"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_adress}
                        rules={{
                            required: <FormattedMessage id="Error.Required" />,
                            maxLength: { value: 255, message: <FormattedMessage id="Error.ShopAdressMaxLenPattern" /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_adress && true}
                            helperText={errors.shop_adress ? errors.shop_adress.message : "例) 沖縄県那覇市久米２－４－１３"}
                            label={<FormattedMessage id={"Shop.ShopAddress"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="shop_e_adress"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_e_adress}
                        rules={{
                            required: <FormattedMessage id="Error.Required" />,
                            maxLength: { value: 255, message: <FormattedMessage id="Error.ShopAdressMaxLenPattern" /> },
                            pattern: { value: /^[0-9a-zA-Z ._-]+$/i, message: <FormattedMessage id="Error.Hankakueisu" /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_e_adress && true}
                            helperText={errors.shop_e_adress ? errors.shop_e_adress.message : ""}
                            label={<FormattedMessage id={"Shop.ShopEAddress"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="latitude"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.latitude}
                        rules={{
                            min: { value: 20.000000, message: <FormattedMessage id="Error.ShopLatMinPattern" /> },
                            max: { value: 45.000000, message: <FormattedMessage id="Error.ShopLatMaxPattern" /> },
                            maxLength: { value: 9, message: <FormattedMessage id="Error.ShopLatLonMaxLenPattern" /> },
                            pattern: { value: /^([1-9]\d*|0)(\.\d+)?$/i, message: <FormattedMessage id="Error.ShopLatLonPattern" /> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.latitude && true}
                            helperText={errors.latitude ? errors.latitude.message : "例) 26.000000"}
                            label={<FormattedMessage id={"Shop.Latitude"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="longitude"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.longitude}
                        rules={{
                            min: { value: 123.000000, message: <FormattedMessage id="Error.ShopLonMinPattern" /> },
                            max: { value: 154.000000, message: <FormattedMessage id="Error.ShopLonMaxPattern" /> },
                            maxLength: { value: 10, message: <FormattedMessage id="Error.ShopLatLonMaxLenPattern" /> },
                            pattern: { value: /^([1-9]\d*|0)(\.\d+)?$/i, message: <FormattedMessage id="Error.ShopLatLonPattern" /> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.longitude && true}
                            helperText={errors.longitude ? errors.longitude.message : "例) 128.000000"}
                            label={<FormattedMessage id={"Shop.Longitude"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="shop_tel"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_tel}
                        rules={{
                            required: <FormattedMessage id="Error.Required" />,
                            minLength: { value: 10, message: <FormattedMessage id="Error.ShopTelFaxMinLenPattern" /> },
                            maxLength: { value: 12, message: <FormattedMessage id="Error.ShopTelFaxMaxLenPattern" /> },
                            pattern: { value: /^[0-9]+$/i, message: <FormattedMessage id="Error.Number" /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_tel && true}
                            helperText={errors.shop_tel ? errors.shop_tel.message : "例) 0989881422"}
                            label={<FormattedMessage id={"Shop.ShopTel"} />} />} />
                </Grid>
                <Grid item xs={6}>
                    <Controller
                        name="shop_fax"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_fax}
                        rules={{
                            minLength: { value: 10, message: <FormattedMessage id="Error.ShopTelFaxMinLenPattern" /> },
                            maxLength: { value: 12, message: <FormattedMessage id="Error.ShopTelFaxMaxLenPattern" /> },
                            pattern: { value: /^[0-9]+$/i, message: <FormattedMessage id="Error.Number" /> }
                        }}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.shop_fax && true}
                            helperText={errors.shop_fax ? errors.shop_fax.message : ""}
                            label={<FormattedMessage id={"Shop.ShopFax"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="shop_cd_3"
                        control={control}
                        onChange={onChange}
                        defaultValue={editing.shop_cd_3}
                        rules={{
                            required: <FormattedMessage id={"Error.Required"} />,
                            maxLength: { value: shopCd3MaxLength, message: <FormattedMessage id="Error.ShopCd3_Pattern" /> },
                            pattern: { value: shopCd3Pattern, message: <FormattedMessage id={"Error.ShopCd3_Pattern"} /> }
                        }}
                        as={<TextField required fullWidth variant="outlined"
                            error={errors.shop_cd_3 && true}
                            helperText={errors.shop_cd_3 ? errors.shop_cd_3.message : "例）000000"}
                            label={<FormattedMessage id={"Shop.ShopCd3"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <Controller
                        name="deals_info"
                        control={control}
                        onChange={onChange}
                        rules={{
                            maxLength: { value: 500, message: <FormattedMessage id="Error.ShopDealInfoMaxLenPattern" /> }
                        }}
                        defaultValue={editing.deals_info}
                        as={<TextField fullWidth variant="outlined"
                            error={errors.deals_info && true}
                            helperText={errors.deals_info ? errors.deals_info.message : ""}
                            label={<FormattedMessage id={"Shop.DealsInfo"} />} />} />
                </Grid>
                <Grid item xs={12}>
                    <FormControl required fullWidth variant="outlined">
                        <InputLabel id="shop-type-label"><FormattedMessage id={"Shop.ShopType"} /></InputLabel>
                        <Controller
                            name="shop_type"
                            control={control}
                            onChange={onChange}
                            defaultValue={editing.shop_type}
                            rules={{
                                required: <FormattedMessage id={"Error.Required"} />
                            }}
                            as={<Select
                                labelId="shop-type-label"
                                id="shop-type"
                                label={<FormattedMessage id={"Shop.ShopType"} />}>
                                <MenuItem value={1}><FormattedMessage id="Shop.ShopType.Fixed" /></MenuItem>
                                <MenuItem value={2}><FormattedMessage id="Shop.ShopType.Movable" /></MenuItem>
                            </Select>} />
                    </FormControl>
                </Grid>

                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={handleBack}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium" color="primary"
                            onClick={handleSubmit(handleNext)}
                            endIcon={submitIcon}>
                            {submitTitle}
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    )
}

export default withStyles(style, { withTheme: true })(ShopEntryStep1);
